import { FormHints, HintProps } from '../FormHints/FormHints.component';
import React, { ComponentPropsWithRef, FC, PropsWithChildren, forwardRef } from 'react';
import { Label, LabelProps } from '@form/components/Label/Label.component';
import { TextareaAutosize, TextareaAutosizeProps } from '@material-ui/core';
import classnames from 'classnames';

import styles from './Textarea.module.scss';

type Props = LabelProps &
  ComponentPropsWithRef<'textarea'> &
  TextareaAutosizeProps &
  HintProps & {
    value?: string;
    autosize?: boolean;
    required?: boolean;
    labelInsideBorder?: boolean;
  };

const Textarea: FC<PropsWithChildren<Props>> = forwardRef(
  (
    {
      label,
      labelI18n,
      labelFlavour,
      autosize,
      className,
      required,
      validators,
      disabled,
      isHintVisible,
      children,
      labelInsideBorder,
      ...rest
    },
    ref
  ) => {
    const rootClassName = classnames(
      styles['plc-textarea'],
      'flex',
      'column',
      isHintVisible && validators && validators.some(v => !v.isValid) && 'error',
      labelInsideBorder && styles['label-in-border'],
      className
    );
    return (
      <label className={rootClassName}>
        <header className="plc-mb-s">
          <Label
            className="width-100"
            label={label}
            labelFlavour={labelFlavour}
            labelI18n={labelI18n}
            labelTag="div"
            required={required}
          />
        </header>
        {autosize ? (
          <TextareaAutosize ref={ref} {...rest} className="small" />
        ) : (
          <textarea ref={ref} className="small" {...rest} />
        )}
        <FormHints isHintVisible={isHintVisible && !disabled} validators={validators} />
        {children}
      </label>
    );
  }
);

export { Textarea };
